import { createFileRoute } from "@tanstack/react-router";
import { NativeEntityKanbanView } from "~/components/NativeEntityKanbanView";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/contacts/view/$viewName")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug, viewName } = Route.useParams();
  return (
    <NativeEntityKanbanView
      entityType="contacts"
      datasetSlug={datasetSlug}
      viewName={viewName}
    />
  );
}
